module.exports = __webpack_public_path__ + "img/bg-dan-abdinoor.ffa32009.jpg";